<template>
  <div>
    <div
      class="loader"
      :style="
        loading
          ? 'display: block !important;  width: 70%;'
          : 'display: none !important;'
      "
    >
      <v-card color="#39424e" width="100px" class="pa-4 ma-auto">
        <div style="width: 90%; margin: auto">
          <v-progress-circular
            size="60"
            indeterminate
            color="#00c7ba"
          ></v-progress-circular>
        </div>
      </v-card>
    </div>
    <div :class="loading ? 'main-card-loader ma-2' : 'card-main'" no-gutters>
      <div class="market-card">
        <div
          style="display: flex; justify-content: end; width: 100%"
          class="div-main-title"
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: end;
              text-align: end;
            "
          >
            <strong
              class="main-title market-title"
              style="color: var(--custom-white-second-color) !important"
            >
              Simule aqui o seguro que garante
              <span
                style="
                  color: var(--custom-white-color);
                  font-family: Arial, Helvetica, sans-serif !important;
                  font-weight: 600;
                "
              >
                a proteção efetiva contra danos causados a terceiros por erros e
                omissões profissionais!
              </span>
            </strong>
          </div>
        </div>
        <div class="final-text mb-6">
          <span
            style="
              color: var(--custom-white-second-color) !important;
              font-family: Arial, Helvetica, sans-serif !important;
            "
          >
            É facil, rápido e 100% online.
          </span>
        </div>
        <div class="image-container mt-8">
          <v-img
            :src="
              socio
                ? socio.logo
                : '../../../../assets/Marca_Globus_negativa.png'
            "
            contain
            class="logo-globus"
          ></v-img>
        </div>
      </div>
      <div class="form-card pa-6 pb-8">
        <div class="my-3" style="height: 100px; width: 85%">
          <p
            style="
              width: 100%;
              text-align: center !important;
              font-family: Arial, Helvetica, sans-serif !important;
              font-weight: 500;
              color: #013 !important;
              font-size: 24px;
            "
            class="text-secure"
          >
            SEGURO DE RESPONSAILIDADE CIVIL PROFISSIONAL ÁREA DA SAÚDE
          </p>
        </div>
        <div class="sub-form pb-7 px-6">
          <div class="text-end" style="width: 85% !important">
            <v-form
              ref="form"
              class="text-start"
              style="width: 100% !important; margin-top: 3rem !important"
            >
              <span class="navigation-title"> Insira seus dados </span>
              <div class="mt-6">
                <span class="label-bold">E-mail</span>
                <v-text-field
                  class="primary-input"
                  outlined
                  dense
                  placeholder="example@mail.com"
                  :rules="[
                    (v) => !!v || 'Insira seu e-mail',
                    (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
                  ]"
                  v-model="user.nm_email"
                ></v-text-field>
              </div>
              <div>
                <span class="label-bold">CPF</span>
                <v-text-field
                  class="primary-input"
                  outlined
                  placeholder="CPF completo"
                  :rules="cpfRules"
                  dense
                  v-mask="['###.###.###-##']"
                  v-model="user.nr_cpf_cnpj"
                ></v-text-field>
              </div>
            </v-form>
            <v-btn
              :style="
                socio
                  ? `color: var(--custom-white-second-color) !important; background-color: ${socio.cor} !important;`
                  : 'color: var(--custom-white-second-color) !important;'
              "
              class="primary-button mt-3 mb-6"
              @click="submit"
              :loading="loading"
            >
              Começar
            </v-btn>
          </div>
          <v-dialog
            v-model="termsDialog"
            persistent
            style="border-radius: 25px !important"
            width="600"
          >
            <v-card
              class="text-left pa-4"
              width="100%"
              v-show="termsDialog"
              color="#f5f5f5"
              style="border-radius: 25px !important"
            >
              <strong style="font-size: 20px" class="mb-6"
                >Termos de Aderência à LGPD</strong
              >
              <p
                v-if="!viewTerms"
                @click="viewTerms = true"
                style="
                  font-size: 13px;
                  text-decoration: underline;
                  margin-top: 0.3rem;
                  color: #00c7ba;
                  cursor: pointer;
                "
              >
                Vizualizar termos...
              </p>
              <p
                v-else
                style="
                  font-size: 13px;
                  height: 150px !important;
                  overflow-y: scroll;
                  border: 1px solid #00c7ba;
                  padding: 7px;
                  border-radius: 10px;
                  margin-top: 0.7rem;
                  margin-bottom: 0 !important;
                "
              >
                O(A) corretor(a) nomeado(a) e que intermedeia a operação
                descrita na proposta declara estar ciente e cumprir as
                obrigações previstas na Lei 13.709/2018 (Lei Geral de Proteção
                de Dados Pessoais – LGPD), e atesta ter previamente informado ao
                seu cliente (Segurado) que: (i) os dados pessoais por ele
                fornecidos seriam compartilhados com a Fator Seguradora para a
                finalidade de análise do risco e contratação de seguro,
                obedecendo-se as normas aplicáveis; (ii) referidos dados podem
                ser eventualmente compartilhados com parceiros atuantes no
                mercado securitário, por questões regulatórias do mercado de
                seguros; e (iii) em caso de não contratação do seguro, os
                respectivos dados poderiam ser armazenados pela Fator Seguradora
                para a finalidade exclusiva de substanciar eventuais futuras
                emissões. <br />
                <br />
                <span>
                  Declara ainda que possui cadastro ativo junto à
                  Superintendência de Seguros Privados – SUSEP, nos termos da
                  Circular SUSEP nº 602/2020, e observa todas as normas legais e
                  infralegais a que estiver sujeito pelo exercício da sua
                  profissão, em especial: (i) a Circular da SUSEP nº 605/2020,
                  que trata da guarda de documentos e armazenamento de dados;
                  (ii) a Lei nº 13.709/2018 (LGPD) sobre proteção e tratamento
                  de dados pessoais; (iii) a Circular SUSEP 612/2020 e Lei nº
                  9.613/1998 relacionadas à prevenção e combate dos crimes de
                  “lavagem” ou ocultação de bens, direitos e valores; e (iv) a
                  Resolução CNSP nº 382/2020, que trata do relacionamento com os
                  adquirentes de produtos securitários. Em vista disso, tem
                  ciência de que deve disponibilizar, formalmente, aos clientes,
                  o montante de sua comissão/remuneração pela intermediação da
                  apólice, nos termos das normas aplicáveis.
                </span>
              </p>

              <p
                v-if="viewTerms"
                style="
                  font-size: 13px;
                  text-decoration: underline;
                  color: #00c7ba;
                  cursor: pointer;
                "
                @click="viewTerms = false"
              >
                Ver menos
              </p>
              <div class="pa-4 d-flex justify-center flex-column align-center">
                <v-alert
                  class="d-flex align-center"
                  :color="$vuetify.theme.primary || '#00c7ba'"
                  type="info"
                  style="
                    font-size: 14px;
                    color: var(--custom-white-second-color) !important;
                  "
                >
                  Está ciente e de acordo que as informações prestadas serão
                  tratadas em conformidade com os termos LGPD?
                </v-alert>
                <v-btn
                  style="
                    height: 30px !important;
                    text-transform: none !important;
                    color: var(--custom-white-second-color) !important;
                    width: 100%;
                  "
                  class="mr-2"
                  :color="$vuetify.theme.primary || '#00c7ba'"
                  @click="
                    termsDialog = false;
                    acceptLGPD = true;
                  "
                  >Estou Ciente
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import GeneralService from "../../../../services/GeneralServices";
import moment from "moment";
export default {
  name: "initial",

  data() {
    return {
      acceptLGPD: false,
      visibleError: false,
      termsDialog: false,
      socio: null,
      loading: true,
      user: {
        nm_pessoa: "",
        nr_cpf_cnpj: "",
        cd_tipo_pessoa: 1,
      },
      viewTerms: true,
      generalService: new GeneralService(),
      api: new ApiService(),
      cpfRules: [
        (v) => !!v || "Insira seu CPF completo",
        (v) => this.generalService.validateCPF(v) || "CPF inválido",
      ],
      cnpjRules: [
        (v) => !!v || "Insira seu CNPJ completo",
        (v) => this.generalService.validateCNPJ(v) || "CNPJ inválido",
      ],
    };
  },

  async created() {
    await this.getSocioAsync();
    const styleElement = document.createElement("style");
    styleElement.textContent = `:root {
      --custom-primary-color: ${this.$vuetify.theme.primary || "#00C7BA"};
      --custom-white-color: ${
        this.socio
          ? !this.isColorDark(this.socio.cor)
            ? "#013"
            : "#fff"
          : "#00C7BA"
      };
      --custom-white-second-color: ${
        this.socio
          ? !this.isColorDark(this.socio.cor)
            ? "#013"
            : "#fff"
          : "#fff"
      };
      --custom-second-color: ${this.$vuetify.theme.primary || "#39424e"};
     }`;
    document.head.appendChild(styleElement);
    if (this.socio) {
      !this.isColorDark(this.socio.cor)
        ? this.$store.commit("SET_COLOR_DARK_OR_LIGHT", "#013")
        : this.$store.commit("SET_COLOR_DARK_OR_LIGHT", "#00C7BA");
    } else {
      this.$store.commit("SET_COLOR_DARK_OR_LIGHT", "#00C7BA");
    }
    localStorage.setItem("id_parceiro", this.$route.query.pc);
    localStorage.setItem("creator_cpf", this.$route.query.pf);
    this.authorizationApi();
  },

  methods: {
    async getSocioAsync() {
      let pc = this.$route.query.pc;
      const loja = this.$route.query.loja;
      const pf = this.$route.query.pf;
      const indicacao = this.$route.query.indicacao;
      if (!pc) pc = "Globus";
      
      if (pc || loja) {
        const queryInfos = {
          pc,
          pf,
          loja,
          indicacao,
        };
        localStorage.setItem("queryInfos", JSON.stringify(queryInfos));
        const url = "https://globusesteiraback.azurewebsites.net/api/";
        // const url = "http://localhost:3007/api/"
        await this.api
          .get(
            `${url}loja/get-logo-by-lojaId?id_parceiro=${this.$route.query.pc}&lojaId=${this.$route.query.loja}&cpf_corretor=${this.$route.query.pf}&id_produto=rc_medico`
          )
          .then((response) => {
            if (response) {
              const foramtData = {
                ...response,
                cor: response.cor.substring(0, 7),
                bgcolor: response.bgcolor.substring(0, 7),
              };

              localStorage.setItem("sessionId", response.clickId);

              localStorage.setItem(
                "queryInfos",
                JSON.stringify({
                  ...queryInfos,
                  emailSocio: foramtData.emailSocio,
                })
              );

              this.socio = foramtData;
              console.log(this.socio);
              const favicon = document.getElementById("favicon");
              favicon.setAttribute(
                "href",
                this.socio.logo || `${process.env.BASE_URL}globus.svg`
              );
              localStorage.setItem("socio", JSON.stringify(foramtData));
              this.$store.commit("SET_SOCIO", foramtData);
              this.$vuetify.theme.primary = foramtData.cor;
            }
            this.termsDialog = true;
          })
          .catch((error) => {
            localStorage.setItem(
              "apiErrorDescription",
              "Erro ao pegar o socio!"
            );
          });
      }
      this.loading = false;
    },
    async authorizationApi() {
      const response = await this.api
        .get("authorization")
        .then((response) => {
          if (response.access_token) {
            localStorage.setItem("token", response.access_token);
            localStorage.setItem(
              "expires_token",
              moment().add(1, "hours").format("YYYY-MM-DD HH:mm:ss")
            );
          } else {
            this.$toast.error("Ocorreu um erro na comunicacao!");
          }
        })
        .catch(() => {
          localStorage.setItem("apiErrorDescription", "Erro na autenticação!");
        });
    },
    async submit() {
      if (this.$refs.form.validate() && this.acceptLGPD) {
        localStorage.setItem("LGDD ACCEPTED", true);
        localStorage.setItem("user", JSON.stringify(this.user));
        await this.generalService.saveSessionInfo({
          email: this.user.nm_email,
          cpf: this.user.nr_cpf_cnpj,
        });
        this.$emit("next", this.user);
      } else if (!this.acceptLGPD) {
        this.$toast.info("Aceite os termos para continuar");
        this.termsDialog = true;
      } else {
        this.$toast.info("Preencha os campos corretamente");
      }
    },
    isColorDark(color) {
      if (!color) {
        return false;
      }
      const luminosity = this.calculateLuminosity(color);
      return luminosity < 128;
    },
    isColorLight(color) {
      return !this.isColorDark(color);
    },
    calculateLuminosity(color) {
      const rgb = this.hexToRgb(color);
      const luminosity = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
      return luminosity * 255;
    },
    hexToRgb(hex) {
      const bigint = parseInt(hex.replace("#", ""), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return {
        r: r / 255,
        g: g / 255,
        b: b / 255,
      };
    },
  },
};
</script>

<style scoped>
.main-card {
  display: flex;
  background: #ffffff;
  border-radius: 25px !important;
}

.main-card-loader {
  display: flex;
  border-radius: 25px !important;
  filter: blur(30px) !important;
}

.loader {
  position: absolute;
  top: 300px;
  left: 200px;
  z-index: 100;
  margin: auto;
}
.market-card {
  background: var(--custom-second-color) url("../../../../assets/Medico.png")
    no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 50%;
  padding: 100px 30px 30px 60px !important;
  text-align: end;
  border-radius: 25px 0px 0px 25px !important;
}

.card-main {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}

.image-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  height: 100%;
}

.logo-title {
  color: #fff !important;
  font-weight: 500 !important;
  letter-spacing: 0.75px !important;
}

.logo-globus {
  max-width: 200px !important;
}

.market-title {
  font-family: Arial, Helvetica, sans-serif !important;
  font-size: 30px !important;
  letter-spacing: 0.15px !important;
  color: #fff !important;
  font-weight: normal !important;
  width: 70%;
}

.market-title-blue {
  font-family: Arial, Helvetica, sans-serif !important;
  font-size: 30px !important;
  letter-spacing: 0.15px !important;
  font-weight: normal !important;
  color: #00c7ba !important;
}

.final-text {
  display: flex;
  align-items: end;
  justify-content: flex-end;
  font-weight: 600;
  font-family: Arial, Helvetica, sans-serif !important;
  font-size: 30px;
  width: 100%;
  padding-top: 2rem;
  text-align: end;
}

.final-text span {
  width: 43%;
}

.form-card {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 50%;
}

.sub-form {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 !important;
  margin: 0 !important;
}

@media (max-width: 1000px) {
  .market-title {
    font-size: 20px !important;
    width: 70%;
  }

  .market-title-blue {
    font-size: 20px !important;
  }

  .final-text {
    font-size: 20px !important;
  }

  .logo-globus {
    max-width: 150px !important;
  }
}

@media (max-width: 855px) {
  .card-main {
    flex-direction: column;
  }

  .card-main div:first-child {
    width: 100%;
  }

  .form-card {
    width: 100%;
  }
}

@media (max-width: 490px) {
  .market-title {
    font-size: 16px !important;
    width: 50%;
  }

  .market-title-blue {
    font-size: 16px !important;
  }

  .final-text {
    font-size: 16px !important;
  }

  .text-secure {
    font-size: 20px !important;
  }

  .navigation-title {
    font-size: 20px !important;
  }

  .logo-globus {
    display: none !important;
  }
}

@media (max-width: 330px) {
  .market-title {
    font-size: 11px !important;
    width: 50%;
  }

  .market-title-blue {
    font-size: 11px !important;
  }

  .final-text {
    font-size: 11px !important;
  }
}
</style>
